import React, { useState } from 'react';
import { Col, Input, Row, Label, Button, Badge, InputGroup, InputGroupAddon, InputGroupText, Tooltip } from 'reactstrap';
import Select from 'react-select';
import { ToolTips } from '../../../components/tooltips/ToolTips';
import machine from '../../../assets/images/dashboard/machine1.png';
import gato from '../../../assets/images/loginHelenLabs/Dicount/UserDiscount.svg'
import { useInputCurves } from '../../../hooks/captureResults/useInputCurves';
import moment from 'moment';

export const InputsCurves = ({ listCurves = [], handleChangeCurveResult, releaseData, handleChangeCurveTime, disabledInputFollowUp,handleResetResultCurves, setChanged  }) => {
    // console.log("🚀 ~ InputsCurves ~ listCurves:", listCurves)

    const {
        formatRange, limitDecimals, getStepFromDecimals, getIconForResult, timeCurves, canResetCurves

    } = useInputCurves();

    const isAnyCurveReleasedOrValidated = listCurves.some(exam =>
    exam.curves.some(curve => curve.released_at !== null || curve.validated_at !== null)
    );



    const ButtonComments = ({ curve = {}, index = 0, examId = 0, showIcon = false }) => {
    const tooltipLockId = `tooltip-lock-${examId}-${index}`;
    const [tooltip, setTooltip] = useState(null);

    const isReleased = !!curve.released_at;
    const isValidated = !!curve.validated_at;

    const iconColor = showIcon ? 'text-success' : 'text-dark';

    const enableTooltip = isReleased || isValidated;

    return (
        <>
        {showIcon && (
            <InputGroupText style={{ padding: '2px 5px', height: '31px' }}>
            <i
                id={tooltipLockId}
                className={`icofont icofont-ui-lock ${iconColor}`}
                style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '0 2px',
                cursor: enableTooltip ? 'pointer' : 'default'
                }}
                onClick={enableTooltip ? () => setTooltip(prev => prev === tooltipLockId ? null : tooltipLockId) : undefined}
            />
            {enableTooltip && (
                <Tooltip
                placement="top"
                isOpen={tooltip === tooltipLockId}
                target={tooltipLockId}
                toggle={() => setTooltip(prev => prev === tooltipLockId ? null : tooltipLockId)}
                >
                {`${isReleased ? 'Liberado' : 'Validado'} el ${moment(isReleased ? curve.released_at : curve.validated_at).format("DD/MM/YYYY hh:mm a")} por ${isReleased ? curve.name_user_release : curve.name_user_validate || ""}`}
                </Tooltip>
            )}
            </InputGroupText>
        )}
        </>
    );
    };

    const [tooltip, setTooltip] = useState(null);

    const isCurveReleasedOrValidated = listCurves.some(exam =>
        exam.curves.some(curve => curve.released_at !== null || curve.validated_at !== null)
    );

    const ViewRelease = (id_work_order_exam, num_sampling) => {
        if (isCurveReleasedOrValidated) return null;

        return (
            <InputGroupText>
            <Button
                className='p-0'
                color='transparent'
                size='xs'
                onClick={() => handleResetResultCurves(id_work_order_exam, num_sampling)}
            >
                <img
                src={require("../../../assets/images/clean.png")}
                alt={`Limpiar toma ${num_sampling}`}
                style={{ cursor: 'pointer', width: '15px', height: '15px' }}
                title={`Limpiar toma ${num_sampling}`}
                />
            </Button>
            </InputGroupText>
        );
    };


    const isCurveValidated = (curve) => {
        return curve.validated_at !== null;
    };

    const anyCaptured = listCurves.some(exam =>
        exam.curves.some(curve => curve.captured_at !== null)
    );

    const anyLocked = listCurves.some(exam =>
    exam.curves.some(curve => 
        curve.validated_at !== null || 
        curve.released_at !== null
    )
    );

    // console.log('estoy aqui, curvas')


    return (
        <>

            {listCurves.map((exam, examIndex) => (
                <div key={exam.id_exam || examIndex} className="mb-4">

                    {exam.curves.map((curve, index) => (
                        
                        <Row key={`${examIndex}-${index}`} className="align-items-center border-top pt-2 mt-2">
                            <Col xs="12" md="2" className="d-flex align-items-center mb-2 mb-md-0">
                                <Badge id={`tooltip-badge-${examIndex}-${index}`} color="info">
                                    C
                                    <ToolTips
                                        dataPlacement="top"
                                        dataTarget={`tooltip-badge-${examIndex}-${index}`}
                                        dataText="Curva"
                                    />
                                </Badge>
                                &nbsp;&nbsp;
                                <Label className="ms-2 mb-0 ">TOMA {curve.num_sampling}</Label>
                            </Col>

                            <Col xs="12" md="2" className="mb-2 mb-md-0">
                                <small className="form-text text-muted">Tiempo:</small>
                                <InputGroup className="input-group-sm">

                                    <Input
                                        type="select"
                                        tabIndex="-1"
                                        className="form-control form-control-sm"
                                        value={curve.id_curve_time}
                                        onChange={(e) => {
                                            const selectedId = parseInt(e.target.value);
                                            const selectedOption = timeCurves.find(tc => tc.value === selectedId);
                                            if (selectedOption) {
                                            handleChangeCurveTime(exam.id_exam, index, selectedOption);
                                            }
                                        }}

                                        disabled={
                                            anyCaptured ||                              
                                            isCurveValidated(curve) ||    
                                            curve.released_at !== null 
                                        }

                                    >

                                    {timeCurves.map(item => (
                                        <option key={item.value} value={item.value}>
                                        {item.label}
                                        </option>
                                    ))}
                                    </Input>

                                    <InputGroupAddon addonType="append" tabIndex="-1">
                                    <ButtonComments
                                        tooltipId={`tooltip-comment-${examIndex}-${index}`}
                                        curve={curve}
                                        index={index}
                                        examId={exam.id_exam}
                                        showIcon={isAnyCurveReleasedOrValidated}
                                    />
                                    </InputGroupAddon>

                                </InputGroup>
                                </Col>


                                <Col xs="12" md="2" className="mb-2 mb-md-0">
                                <small className="form-text text-muted">
                                    Resultado: Decimales máximos {curve.num_decimals || 2}
                                </small>

                                <InputGroup className="input-group-sm">
                                    <Input
                                    className={`form-control ${index === 0 && !curve.result ? 'border-danger' : ''}`}
                                    type="number"
                                    step={getStepFromDecimals(curve.num_decimals || 2)}
                                    min="0"
                                    value={curve.result || ''}
                                    onChange={(e) => {
                                          setChanged(true);

                                        const val = e.target.value;
                                        const limited = limitDecimals(val, curve.num_decimals || 2);

                                        if (limited !== null) {
                                        handleChangeCurveResult(exam.id_exam, index, limited);
                                        }
                                    }}
                                        disabled={anyLocked}
                                    />

                                    <InputGroupAddon addonType="append" tabIndex="-1">
                                    {ViewRelease(exam.id_work_order_exam, curve.num_sampling)}
                                    </InputGroupAddon>

                                    <InputGroupAddon addonType="append" tabIndex="-1">
                                    <ButtonComments
                                        tooltipId={`tooltip-comment-${examIndex}-${index}`}
                                        curve={curve}
                                        index={index}
                                        examId={exam.id_exam}
                                        showIcon={isAnyCurveReleasedOrValidated}
                                    />
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>

                            <Col xs="6" md="1" className="d-flex align-items-center justify-content-center">
                                {getIconForResult(curve.result, curve.range, true, index)}
                            </Col>

                            <Col xs="6" md="1" className="text-center">
                                {curve.captured_at && (
                                    <>
                                        <img
                                            style={{ cursor: "pointer" }}
                                            className="img-30 mr-1 rounded-circle"
                                            id={`tooltip-capture-${examIndex}-${index}`}
                                            src={curve.is_interfaced ? machine : gato}
                                            alt=""
                                        />
                                        <Tooltip
                                            placement="top"
                                            isOpen={tooltip === `tooltip-capture-${examIndex}-${index}`}
                                            target={`tooltip-capture-${examIndex}-${index}`}
                                            toggle={() => {
                                                if (tooltip === `tooltip-capture-${examIndex}-${index}`) {
                                                    setTooltip(null);
                                                } else {
                                                    setTooltip(`tooltip-capture-${examIndex}-${index}`);
                                                }
                                            }}
                                        >
                                            {
                                                curve.is_interfaced
                                                    ? `${moment(curve.captured_at).format("DD/MM/YYYY hh:mm a")} - Resultado interfazado`
                                                    : `${moment(curve.captured_at).format("DD/MM/YYYY hh:mm a")} - Capturado por: ${curve.name_user_capture || "Sistema"}`
                                            }
                                        </Tooltip>
                                    </>
                                )}
                            </Col>



                            <Col xs="6" md="2" className="text-start">
                                <span>
                                    {curve.name_unit && curve.name_unit.trim() !== "" ? curve.name_unit : "Sin unidad"}
                                </span>
                            </Col>

                            <Col xs="6" md="2" className="text-start">
                                <span>
                                    {
                                        curve.range && curve.range.trim() !== ""
                                            ? formatRange(curve.range)
                                            : "Sin rango"
                                    }
                                </span>
                            </Col>

                            <hr />
                        </Row>
                    ))}
                </div>
            ))}
        </>
    );
};
